import axios from 'axios';

export const verifyOtp = async (phone, otp) => {
    try {
        // const response = await axios.post("https://asia-south1-equentis-uat-env.cloudfunctions.net/iir-landing-page/verify-otp", {
        //     mobile: `${phone}`,
        //     otp: `${otp}`
        // });

        const response = await axios.post("https://asia-south1-equentis-prod-env.cloudfunctions.net/iir-landing-page/verify-otp", {
            mobile: `${phone}`,
            otp: `${otp}`
        });

        // Axios puts the server response body inside the 'data' property
        return response.data;
    } catch (error) {
        console.error("Error verifying OTP:", error.response?.data || error.message);
        throw error;
    }
}
